"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfDefaultHeightsHasMinimumRequired = void 0;
const checkIfDefaultHeightsHasMinimumRequired = (args) => {
    const typedArgs = args;
    let isValid = true;
    for (const arg of typedArgs) {
        if (!arg.defaultHeights || !(arg.defaultHeights.length > 0)) {
            isValid = false;
            break;
        }
    }
    return isValid;
};
exports.checkIfDefaultHeightsHasMinimumRequired = checkIfDefaultHeightsHasMinimumRequired;
//# sourceMappingURL=argumentValidation.js.map